import React, { useEffect, useState, useRef } from 'react';
import * as CommonHelper from '../../../../helpers/Common.helper';

const VideoLayoutComponent = props => {
    const { mainImageUrl, videoUrlList, windowDimensions, gotoMain } = props;

    const videoRef = useRef(null);
    const [videoIdx, setVideoIdx] = useState(0);
    const [videoSrc, setVideoSrc] = useState(null);
    const [isLoopVideo, setIsLoopVideo] = useState(false);

    useEffect(_ => {
        console.log('useEffect');
        if (videoUrlList.length > 0) {
            setIsLoopVideo(false);
            if (videoUrlList.length == 2) {
                // 비디오 레이아웃은 계속 출력되는 상태
                // * videoIdx의 useState 0 은 최초 한번만
                // * 최초 로드 후 useEffect 가 componentDidUpdate역할을하므로
                // * new material & production 외에는 0번으로 초기화 해줘야함.
                let newVideoIdx = 0;
                setVideoIdx(newVideoIdx)
                setVideoSrc(videoUrlList[newVideoIdx]);
            } else {
                console.log('videoIdx', videoIdx);
                const newVideoIdx = 5;
                console.log(newVideoIdx);
                setVideoIdx(newVideoIdx);
                setVideoSrc(videoUrlList[newVideoIdx]);
            }
        }
    }, [videoUrlList])

    const onTimeUpdate = evt => {
        if (evt.target.currentTime >= evt.target.duration) {
            // 마지막 메뉴(New Material & Production)을 제외한 비디오 플레이 방식
            // * 두번째 비디오 재생시 반복

            console.log('videoUrlList.length', videoUrlList.length);
            console.log('videoIdx', videoIdx)
            if (videoUrlList.length == 2) {

                if (videoIdx === 0) {
                    const newVideoIdx = 1;
                    setVideoIdx(newVideoIdx);
                    setVideoSrc(videoUrlList[newVideoIdx]);
                    setIsLoopVideo(true);
                }
            } else {
                let newVideoIdx = CommonHelper.getRandomNum(0, videoUrlList.length);
                if (newVideoIdx === videoIdx) {
                    if (newVideoIdx === videoUrlList.length - 1) {
                        newVideoIdx = videoUrlList.length - 2;
                    } else {
                        newVideoIdx += 1;
                    }
                }
                console.log(newVideoIdx);
                setVideoIdx(newVideoIdx);
                setVideoSrc(videoUrlList[newVideoIdx]);
            }
        }
    }

    return (
        <div className='media'>
            {windowDimensions.width > 768 ?
                <div className="video">
                    <div className="wrapper">
                        <video key={(new Date()).getTime()} autoPlay={true} loop={isLoopVideo} muted={true}
                            // controls={true} controlsList={true}
                            src={videoSrc} ref={videoRef} onTimeUpdate={onTimeUpdate}>
                        </video>
                        {/* {videoUrlList ?
                        <video key={(new Date()).getTime()} autoPlay={true} loop={false} muted={true} controls={true} controlsList={true}
                            ref={videoRef}
                            onTimeUpdate={onTimeUpdate}>
                            {videoUrlList.map((movieUrl, idx) =>
                                <source key={idx}
                                    src={movieUrl} type="video/mp4" />
                            )}
                        </video>
                        : null} */}
                    </div>
                </div>
                : null}
            <div className="banner">
                <img src={mainImageUrl} />
            </div>
        </div>
    )
}

export default VideoLayoutComponent;